export const enum BetOfferType {
  Handicap = 1,
  '1x2' = 2,
  Result = 3,
  Outright = 4,
  OverUnder = 6,
  AsianHandicap = 7,
  HalfTimeFullTime = 8,
  SideBet = 9,
  OddEven = 10,
  ThreeWayHCP = 11,
  DoubleChance = 12,
  HeadToHead = 13,
  Scorer = 17,
  YesNo = 18,
  MultiPosition = 19,
  AsianOverUnder = 21,
  Position = 117,
  WinningMargin = 124,
  PlayerOccurrenceNumber = 125,
  PlayerLastOccurrence = 126,
  PlayerOccurrenceLine = 127,
  OccurrenceMethod = 128,
}
